import { Store } from "@reduxjs/toolkit";
import { ProductBrandingContainer } from "components/app/product-branding-container";
import ErrorComponent from "components/community-comparison/error";
import { Responsive } from "components/responsive";
import { History } from "history";
import React, { FunctionComponent } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { Provider } from "react-redux";
import { Route, Router, Switch } from "react-router";
import "react-widgets/styles.css";
import "../app/tailwind.css";
import { HostedFormExperience } from "./hosted-form-experience";

interface AppProps {
    // eslint-disable-next-line @typescript-eslint/ban-types -- eslintintroduction
    history: History<{}>;
    store: Store;
}

const queryClient = new QueryClient();

export const HostedFormRoot: FunctionComponent<AppProps> = props => (
    <Provider store={props.store}>
        <Router history={props.history}>
            <QueryClientProvider client={queryClient}>
                <ProductBrandingContainer>
                    <div className="app-component min-h-screen">
                        <Router history={props.history}>
                            <Switch>
                                <Route
                                    path="/hosted-form/error"
                                    exact={true}
                                    component={ErrorComponent}
                                />
                                <Route
                                    path="/hosted-form/:hostedFormId"
                                    component={HostedFormExperience}
                                />
                            </Switch>
                        </Router>
                        <Responsive />
                    </div>
                </ProductBrandingContainer>
            </QueryClientProvider>
        </Router>
    </Provider>
);
